import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpAi'

// Agent Runs
export const getAgentRuns = (params = {}) => Http.get(`/admin/agent-runs${serialize(params)}`)
export const getAgentRun = (uuid) => Http.get(`/admin/agent-runs/${uuid}`)
export const approveAgentRun = (uuid) => Http.post(`/admin/agent-runs/${uuid}/approve`)
export const rejectAgentRun = (uuid) => Http.post(`/admin/agent-runs/${uuid}/reject`)
export const cancelAgentRun = (uuid) => Http.post(`/admin/agent-runs/${uuid}/cancel`)

// Agents
export const getAgents = (params = {}) => Http.get(`/admin/agents${serialize(params)}`)
export const updateAgentStatus = (uuid, status) => Http.patch(`/admin/agents/${uuid}/status`, { status })
